export declare namespace ActivityDataValidationTokenSections {
	interface Button {
		size: string;
		gap: string;
		iconSize: string;
		defaultBackground: string;
		borderColor: string;
	}

	interface Yes {
		background: string;
		borderColor: string;
		iconColor: string;
	}

	interface No {
		background: string;
		borderColor: string;
		iconColor: string;
	}

	interface NotProvided {
		background: string;
		borderColor: string;
		iconColor: string;
	}

	interface PreviousCapacityHint {
		fontSize: string;
		lineHeight: string;
		color: string;
		marginTop: string;
	}
}

export type ActivityDataValidationTokens = {
	button: ActivityDataValidationTokenSections.Button;
	yes: ActivityDataValidationTokenSections.Yes;
	no: ActivityDataValidationTokenSections.No;
	notProvided: ActivityDataValidationTokenSections.NotProvided;
	previousCapacityHint: ActivityDataValidationTokenSections.PreviousCapacityHint;
};

export const button: ActivityDataValidationTokenSections.Button = {
	size: '40px',
	gap: '15px',
	iconSize: '24px',
	defaultBackground: '{named.activity.data.validation.default.background}',
	borderColor: '{surface.200}',
};

export const yes: ActivityDataValidationTokenSections.Yes = {
	background: '{green.100}',
	borderColor: '{green.200}',
	iconColor: '{green.600}',
};

export const no: ActivityDataValidationTokenSections.No = {
	background: '{red.50}',
	borderColor: '{red.100}',
	iconColor: '{red.500}',
};

export const notProvided: ActivityDataValidationTokenSections.NotProvided = {
	background: '{yellow.50}',
	borderColor: '{yellow.100}',
	iconColor: '{yellow.500}',
};

export const previousCapacityHint: ActivityDataValidationTokenSections.PreviousCapacityHint = {
	fontSize: '12px',
	lineHeight: '18px',
	color: '{text.muted.color}',
	marginTop: '4px',
};

/** Tri-state validation controls (Figma Validacija_x / Validacija_y). */
export default {
	button,
	yes,
	no,
	notProvided,
	previousCapacityHint,
} satisfies ActivityDataValidationTokens;
